import React from "react";
import { FaFileAlt } from "react-icons/fa";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ModalComponent from "../../components/ModalComponent";

const SummaryModal = ({ isOpen, onClose, summary, isLoading = false }) => {
  return (
    <ModalComponent
      show={isOpen}
      handleClose={onClose}
      title={
        <div className="d-flex align-items-center gap-2">
          <span>Contract Summary</span>
        </div>
      }
      size="lg"
      footerButtons={[
        {
          label: "Close",
          variant: "secondary",
          onClick: onClose,
        },
      ]}
    >
      <div className="p-3">
        {isLoading ? (
          <div className="text-center p-4">
            <img src="/images/loader.gif" alt="loading..." />
            <p className="mt-2 text-muted">Generating summary...</p>
          </div>
        ) : (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              strong: ({ node, ...props }) => (
                <strong className="fw-bold text-dark" {...props} />
              ),
              em: ({ node, ...props }) => (
                <em className="fst-italic text-secondary" {...props} />
              ),
              h1: ({ node, ...props }) => (
                <h1 className="fs-3 fw-bold mt-3 mb-2" {...props} />
              ),
              h2: ({ node, ...props }) => (
                <h2 className="fs-4 fw-semibold mt-3 mb-2" {...props} />
              ),
              h3: ({ node, ...props }) => (
                <h3 className="fs-5 fw-semibold mt-2 mb-1" {...props} />
              ),
              p: ({ node, ...props }) => (
                <p className="text-muted mb-3 lh-base" {...props} />
              ),
              ul: ({ node, ...props }) => (
                <ul className="ps-4 mb-3" {...props} />
              ),
              li: ({ node, ...props }) => (
                <li className="mb-1" {...props} />
              ),
              table: ({ node, ...props }) => (
                <table className="table table-bordered mt-3" {...props} />
              ),
              code: ({ node, inline, ...props }) =>
                inline ? (
                  <code className="bg-light px-1 rounded text-danger" {...props} />
                ) : (
                  <pre className="bg-light p-2 rounded mt-2">
                    <code {...props} />
                  </pre>
                ),
              blockquote: ({ node, ...props }) => (
                <blockquote
                  className="border-start border-4 border-primary ps-3 text-muted fst-italic my-3"
                  {...props}
                />
              ),
            }}
          >
            {summary || "_No summary available_"}
          </ReactMarkdown>
        )}
      </div>
    </ModalComponent>
  );
};

export default SummaryModal;
